import { render, staticRenderFns } from "./PhotoCapture.vue?vue&type=template&id=f9e1bb86&scoped=true&"
import script from "./PhotoCapture.vue?vue&type=script&lang=js&"
export * from "./PhotoCapture.vue?vue&type=script&lang=js&"
import style0 from "./PhotoCapture.vue?vue&type=style&index=0&id=f9e1bb86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9e1bb86",
  null
  
)

export default component.exports